import React from 'react';
import { cn } from '../../utils/cn';

/**
 * FormField wrapper component for label + input/select/textarea
 *
 * @param {Object} props
 * @param {string} props.label - Label text
 * @param {ReactNode} props.icon - Icon component
 * @param {ReactNode} props.children - Input element
 * @param {string} props.htmlFor - Label for attribute
 * @param {string} props.error - Error message
 * @param {boolean} props.required - Required field indicator
 * @param {string} props.className - Additional CSS classes
 */
export const FormField = ({
  label,
  icon: Icon,
  children,
  htmlFor,
  error,
  required,
  className,
}) => {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {label && (
        <label
          htmlFor={htmlFor}
          className="flex items-center gap-2 text-sm font-medium text-gray-700"
        >
          {Icon && <Icon className="w-4 h-4" aria-hidden="true" />}
          {label}
          {required && <span className="text-red-500" aria-label="required">*</span>}
        </label>
      )}
      {children}
      {error && (
        <p className="text-sm text-red-500" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};
